/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const r=r=>Array.isArray(r);export{r as isKeyframesTarget};
//# sourceMappingURL=is-keyframes-target.js.map
